
































import {computed, defineComponent} from "@vue/composition-api"
import StandardLayout from '@/components/layout/standard/StandardLayout.vue'

export default defineComponent({
  components: {
    StandardLayout,
  },
  setup(props, ctx) {
    const versions = computed(() => ctx.root.$store.state.versions)
    return {versions}
  },
})
